module.exports = __webpack_public_path__ + "img/1f917.ce32944.svg";